<div class="main">
  <div class="dashboardMain">
    <div class="header">
      <div class="headerLabel">
        {{'LOAD_DASHBOARD.title' | translate}}
      </div>
      <div class="refreshIcon" (click)="getOrders()">
        <img src="assets/refresh_new.svg" alt="">
      </div>
    </div>
    <div class="ordersection">
      <div class="load_table">
        <div class="load">
          <div class="desktop-view">
            <table mat-table [dataSource]="dataSource" class="loadTable">
              <ng-container matColumnDef="load">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.load' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  {{element.load}}
                  <br>
                  {{element.materials}}
                </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.uploadedDate' | translate}} <br>
                  {{'LOAD_DASHBOARD.plannedDate' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned" style="word-wrap: break-word;">
                  {{element.created}} <br>
                  {{element.plan_date}}
                </td>
              </ng-container>

              <ng-container matColumnDef="material">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.material' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  {{element.materials}}
                </td>
              </ng-container>

              <ng-container matColumnDef="customer">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.customer' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  <div *ngFor="let cust of element.customer">
                    {{cust.name}}<br>
                    <span *ngIf="cust.city">{{cust.city}} - </span> {{cust.locality}}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="allocated">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.allocated' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  {{element.allocated}}
                  <br>
                  <div *ngIf="element.allocated - element.accepted > 0" class="buttonMain"
                    (click)="$event.stopPropagation(); acceptLoad(element)">
                    <div class="button">
                      Accept
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="accepted">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.accepted' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  {{element.accepted}}
                  <br>
                  <div *ngIf="(element.accepted - element.assigned) > 0" class="buttonMain"
                    style="background: #48C479;border: 1px solid #48C479;"
                    (click)="$event.stopPropagation();openAssignModal(element)">
                    <div class="button">
                      Assign
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="assigned">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.assigned' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  {{element.vehicle_no ? element.vehicle_no + ' - ' + element.assigned : element.assigned}}
                </td>
              </ng-container>

              <ng-container matColumnDef="plantDate">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.plantDate' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" style="word-wrap: break-word;">
                  {{element.created}}
                </td>
              </ng-container>

              <ng-container matColumnDef="shipper">
                <th mat-header-cell *matHeaderCellDef class="customHeader">
                  {{'LOAD_DASHBOARD.shipper' | translate}}
                </th>
                <td mat-cell *matCellDef="let element" class="center-aligned">
                  <span>{{element.shipper ? element.shipper.parent_name + ' - ' + element.shipper.name : ''}}
                  </span>
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef  class="customHeader">
                      {{'LOAD_DASHBOARD.actions' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let element">
                      <div style="text-align:center;display:inline-block;margin-top:5px" >
                          <button [disabled]="(element.accepted >0)" class="accept_btn" (click)=" $event.stopPropagation(); acceptLoad(element) " >
                              {{'LOAD_DASHBOARD.accept' | translate}}
                          </button>
                      </div>
                  </td>
                </ng-container> -->
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"
                style="font-weight: bold !important; height: 50px"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;let i=index;"
                style="font-family: 'Muli', sans-serif;" (click)="tabIndex = 0;(openAssignSideModal(row));">
              </tr>
            </table>
          </div>

          <div class="mobile-view">
            <div class="load-card" *ngFor="let element of dataSource.data"
              (click)="tabIndex = 0;(openAssignSideModal(element));">
              <div class="card-header">
                <div class="load-id">{{element.load}}</div>
                <div class="load-date">{{element.created}}</div>
              </div>

              <div class="card-body">
                <div class="card-row">
                  <div class="card-label">{{'LOAD_DASHBOARD.material' | translate}}:</div>
                  <div class="card-value">{{element.materials}}</div>
                </div>

                <div class="card-row">
                  <div class="card-label">{{'LOAD_DASHBOARD.customer' | translate}}:</div>
                  <div class="card-value">
                    <div *ngFor="let cust of element.customer">
                      {{cust.name}}
                      <div class="customer-location">
                        <span *ngIf="cust.city">{{cust.city}} - </span>{{cust.locality}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-row">
                  <div class="card-label">{{'LOAD_DASHBOARD.plannedDate' | translate}}:</div>
                  <div class="card-value">{{element.plan_date}}</div>
                </div>

                <div class="card-row">
                  <div class="card-label">{{'LOAD_DASHBOARD.shipper' | translate}}:</div>
                  <div class="card-value">{{element.shipper ? element.shipper.parent_name + ' - ' + element.shipper.name
                    : ''}}</div>
                </div>
              </div>

              <div class="card-stats">
                <div class="stat-item">
                  <div class="stat-label">{{'LOAD_DASHBOARD.allocated' | translate}}</div>
                  <div class="stat-value">{{element.allocated}}</div>
                </div>

                <div class="stat-item">
                  <div class="stat-label">{{'LOAD_DASHBOARD.accepted' | translate}}</div>
                  <div class="stat-value">{{element.accepted}}</div>
                </div>

                <div class="stat-item">
                  <div class="stat-label">{{'LOAD_DASHBOARD.assigned' | translate}}</div>
                  <div class="stat-value">{{element.vehicle_no ? element.vehicle_no + ' - ' + element.assigned :
                    element.assigned}}</div>
                </div>
              </div>

              <div class="card-actions">
                <div *ngIf="element.allocated - element.accepted > 0" class="card-button accept-button"
                  (click)="$event.stopPropagation(); acceptLoad(element)">
                  Accept
                </div>

                <div *ngIf="(element.accepted - element.assigned) > 0" class="card-button assign-button"
                  (click)="$event.stopPropagation();openAssignModal(element)">
                  Assign
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer desktop-footer">
          <mat-paginator fixed [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
            style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"
            [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageNavigate($event)"></mat-paginator>
        </div>

        <div class="mobile-footer">
          <mat-paginator fixed [length]="(dataSource)? totalOrders:0" [showFirstLastButtons]="true" [pageSize]="25"
            [pageSizeOptions]="[5, 10, 25]" (page)="pageNavigate($event)"></mat-paginator>
        </div>
      </div>

      <div class="semiTransparentBackground" [hidden]="!showStatusTab" [@fadeIn]></div>

      <div class="statusTab" *ngIf="showStatusTab" [@slideInOut]>
        <i class="material-icons close-icon" (click)="showStatusTab=0; selectedOrderData={}; tab=0;">clear</i>

        <div class="assignDetails">
          <div class="statusHeader">
            <mat-grid-list cols="2" rowHeight="3:1">
              <mat-grid-tile>
                <span>{{'ORDER_DASHBOARD.allocStatus' | translate}}</span>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
          <div class="allocationData">
            <div class="statusBody">
              <div class="allocTable">
                <div class="table">
                  <div class="accordions">
                    <mat-accordion style="font-family: 'Muli', sans-serif;">
                      <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'ORDER_DASHBOARD.allocatedOn' | translate}} - {{created_date}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="allocation desktop-allocation">
                          <table mat-table #allocTable class="allocationTable" [dataSource]="allocationArray">
                            <ng-container matColumnDef="slno">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div style="position: relative;top: 10px;">
                                  {{'ORDER_DASHBOARD.siNo' | translate}}
                                </div>
                              </th>
                              <td mat-cell *matCellDef="let element;let i= index;"> {{i+1}} </td>
                            </ng-container>

                            <ng-container matColumnDef="requested">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Request.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.requested' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.allocated}} </td>
                            </ng-container>

                            <ng-container matColumnDef="accepted">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Accepted.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.accepted' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.accepted}} </td>
                            </ng-container>

                            <ng-container matColumnDef="assigned">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Assign.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.assigned' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.assigned}} </td>
                            </ng-container>

                            <ng-container matColumnDef="cancelled">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon"><img style="width: 18px;position: relative"
                                    src="assets/Cancelled.svg" alt=""></div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.cancelled' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.cancelled}} </td>
                            </ng-container>

                            <ng-container matColumnDef="deadline">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Deadline.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.deadline' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"
                                [ngStyle]="{'color':element.disableAssign || element.disableAccept ? '#000':'#e54031'}">
                                <span *ngIf=" element.accepted != 0 && element.assignmentDeadline"
                                  style="font-size: 10px;"
                                  [ngStyle]="{'color':element.disableAssign ? '#000':'#e54031'}">{{'ORDER_DASHBOARD.assignBefore'
                                  | translate}}</span>
                                <span *ngIf="element.accepted == 0 && element.acceptanceDeadline"
                                  style="font-size: 10px;"
                                  [ngStyle]="{'color':element.disableAccept ? '#000':'#e54031'}">{{'ORDER_DASHBOARD.acceptBefore'
                                  | translate}}</span><br>
                                {{ (element.accepted != 0) ? element.assignmentDeadline : element.acceptanceDeadline}}
                              </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div style="position: relative;top: 10px;">{{'ORDER_DASHBOARD.action'
                                  | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element">
                                <mat-icon class="more-icon" [matMenuTriggerFor]="actions"
                                  (click)="$event.stopPropagation()" style="cursor:pointer">
                                  more_vert</mat-icon>
                                <mat-menu #actions="matMenu">
                                  <button [disabled]="!element.disableAccept" mat-menu-item
                                    (click)="(element.disableAccept)? openAcceptModal(element,'accept') : '';">
                                    {{'ORDER_DASHBOARD.accept' | translate}}</button>
                                  <button mat-menu-item (click)=" openAcceptModal(element,'view') ">
                                    {{'View' | translate}}</button>
                                  <button *ngIf='element.accepted != 0 && element.accepted > 0' mat-menu-item
                                    (click)="openAssignModal(element)">
                                    {{'ORDER_DASHBOARD.assign' | translate}}</button>
                                </mat-menu>
                                <div class="rejected" *ngIf="element.disable_btns">
                                  <p style="color: #D8511F;">Rejected</p>
                                </div>
                              </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="allocationColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: allocationColumns;"></tr>
                          </table>
                        </div>

                        <div class="allocation mobile-allocation">
                          <div class="allocation-card" *ngFor="let element of allocationArray; let i = index">
                            <div class="allocation-card-header">
                              <div class="allocation-number">#{{'ORDER_DASHBOARD.siNo' | translate}}: {{i+1}}</div>
                            </div>

                            <div class="allocation-stats">
                              <div class="allocation-stat">
                                <div class="stat-icon">
                                  <img src="assets/Request.svg" alt="">
                                </div>
                                <div class="stat-info">
                                  <div class="stat-label">{{'ORDER_DASHBOARD.requested' | translate}}</div>
                                  <div class="stat-value">{{element.allocated}}</div>
                                </div>
                              </div>

                              <div class="allocation-stat">
                                <div class="stat-icon">
                                  <img src="assets/Accepted.svg" alt="">
                                </div>
                                <div class="stat-info">
                                  <div class="stat-label">{{'ORDER_DASHBOARD.accepted' | translate}}</div>
                                  <div class="stat-value">{{element.accepted}}</div>
                                </div>
                              </div>

                              <div class="allocation-stat">
                                <div class="stat-icon">
                                  <img src="assets/Assign.svg" alt="">
                                </div>
                                <div class="stat-info">
                                  <div class="stat-label">{{'ORDER_DASHBOARD.assigned' | translate}}</div>
                                  <div class="stat-value">{{element.assigned}}</div>
                                </div>
                              </div>

                              <div class="allocation-stat">
                                <div class="stat-icon">
                                  <img src="assets/Cancelled.svg" alt="">
                                </div>
                                <div class="stat-info">
                                  <div class="stat-label">{{'ORDER_DASHBOARD.cancelled' | translate}}</div>
                                  <div class="stat-value">{{element.cancelled}}</div>
                                </div>
                              </div>
                            </div>

                            <div class="allocation-deadline"
                              [ngStyle]="{'color':element.disableAssign || element.disableAccept ? '#000':'#e54031'}">
                              <div class="deadline-icon">
                                <img src="assets/Deadline.svg" alt="">
                              </div>
                              <div class="deadline-info">
                                <div class="deadline-label">{{'ORDER_DASHBOARD.deadline' | translate}}</div>
                                <div class="deadline-value">
                                  <span *ngIf="element.accepted != 0 && element.assignmentDeadline"
                                    [ngStyle]="{'color':element.disableAssign ? '#000':'#e54031'}">
                                    {{'ORDER_DASHBOARD.assignBefore' | translate}}
                                  </span>
                                  <span *ngIf="element.accepted == 0 && element.acceptanceDeadline"
                                    [ngStyle]="{'color':element.disableAccept ? '#000':'#e54031'}">
                                    {{'ORDER_DASHBOARD.acceptBefore' | translate}}
                                  </span>
                                  <div>{{ (element.accepted != 0) ? element.assignmentDeadline :
                                    element.acceptanceDeadline}}</div>
                                </div>
                              </div>
                            </div>

                            <div class="allocation-actions">
                              <div class="rejected" *ngIf="element.disable_btns">
                                <p>Rejected</p>
                              </div>

                              <button class="action-button" [disabled]="!element.disableAccept"
                                (click)="(element.disableAccept)? openAcceptModal(element,'accept') : '';">
                                {{'ORDER_DASHBOARD.accept' | translate}}
                              </button>

                              <button class="action-button view-button" (click)="openAcceptModal(element,'view')">
                                {{'View' | translate}}
                              </button>

                              <button *ngIf='element.accepted != 0 && element.accepted > 0'
                                class="action-button assign-button" (click)="openAssignModal(element)">
                                {{'ORDER_DASHBOARD.assign' | translate}}
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>

              <ng-template #noVersions>
                <div class="noVersions" style="padding-top: 30px;text-align: center;">
                  {{'ORDER_DASHBOARD.noStatus' | translate}}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>

      <ng-template #noOrders>
        <div class="noOrders" style="padding: 30px; text-align: center;">
          {{'ORDER_DASHBOARD.noOrder' | translate}}
        </div>
      </ng-template>
    </div>
  </div>
</div>